__turbopack_context__.v({
  "activitiesList__separator": "ActivitiesList-module__xnGAqW__activitiesList__separator",
});
